<!--  search content classic view-->
<div class="mt-2 container-fluid w-100 pl-4 pr-4 ricerca" *ngIf="!boxView">

  <app-spinner *ngIf="isSearchLoading()"></app-spinner>

  <!--    vista classica-->
  <div *ngIf="!isSearchLoading() && searchResults?.length > 0" class="shadow p-1 p-md-2 mb-3 results">
    <div class="row head-orders justify-content-start text-break">
      <div class="col-5 col-xl-4 font-weight-bold">
        {{'NAME' | translate}}
      </div>
      <div class="col-3 col-xl-2 font-weight-bold">
        {{'OPERATOR' | translate}}
      </div>
      <div class="col-1 col-xl-1 font-weight-bold">
        {{'ARTICLE_TYPE' | translate}}
      </div>
      <div class="col-xl-3 font-weight-bold d-none d-xl-block">
        {{'CREATION_DATE' | translate}}
      </div>
      <div class="col-1 col-xl-1 font-weight-bold">
        {{'PRIVATE' | translate}}
      </div>
      <div class="col-1 col-xl-1 font-weight-bold">
        {{'ACTIONS' | translate}}
      </div>
    </div>
    <!--      righe risultati-->
    <ng-container
      *ngFor="let draft of searchResults;let i = index">
      <div class="row justify-content-start" [ngClass]="{'colored-row': 0 === i % 2}">
        <!--nome-->
        <div class="col-5 col-xl-4 align-self-center primary-color">
          <a class="cursor-pointer"
             title="{{draft.name | translate}}"
             (click)="openProcess(draft)">
            <u class="text-truncate d-block no-underline">{{draft.name | translate}}</u>
          </a>
        </div>
        <!--          operatore-->
        <div class="col-3 col-xl-2 align-self-center">
          {{draft.operator.identityId || draft.operator.uida}}
        </div>
        <!--          tipo-->
        <div class="col-1 col-xl-1 align-self-center">
          <img src="ui-resources/{{draft.articleTypes[0]}}.png"
               class="img-fluid rounded pr-1" alt="{{draft.articleTypes[0]}}"
               title="{{'ARTICLE_TYPES.' + draft.articleTypes[0] | translate}}" style="height: 24px"></div>
        <!--          data creazione-->
        <div class="col-xl-3 align-self-center d-none d-xl-block">
          {{draft.creationDate.format('DD/MM/YYYY, HH:mm')}}
        </div>
        <!--          riservata-->
        <div class="col-1 col-xl-1 align-self-center">
          <i *ngIf="!draft.reserved" class="fas fa-lock-open text-success"></i>
          <i *ngIf="draft.reserved" class="fas fa-lock text-muted"></i>
        </div>
        <!--          actions-->
        <div class="col-1 col-xl-1 font-weight-bold">
          <div class="row flex-nowrap" *ngIf="checkSameOperator(draft) || !draft.reserved">
            <i *ngIf="draft.name !== 'LAST_DRAFT'" class="fas fa-pencil-alt cursor-pointer pr-3 text-warning"
               title="{{'BUTTON.EDIT' | translate}}"
               role="button"
               (click)="onEdit(draft)"></i>
            <i *ngIf="!draft.deleteMode && draft.name !== 'LAST_DRAFT'"
               class="far fa-trash-alt cursor-pointer text-danger delete-draft"
               title="{{'BUTTON.DELETE' | translate}}" role="button"
               (click)="onDelete(draft)"></i>
            <i class="fas fa-exclamation-circle cursor-pointer text-warning m-0 p-0 confirm-delete-draft"
               [id]="'draft'+draft.processId"
               *ngIf="draft.deleteMode && draft.name !== 'LAST_DRAFT'"
               (click)="onDeleteConfirm(draft)"
               tabindex="0"
               role="button"
               data-toggle="popover"
               data-trigger="focus"
               [attr.data-content]="'CONFIRM_MESSAGE'|translate"
               title="{{'MESSAGE.TITLE.WARNING' | translate}}"></i>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<!--    box view-->
<div class="container-fluid w-100 ricerca m-0 p-0" *ngIf="boxView">

  <app-spinner *ngIf="isSearchLoading()"></app-spinner>

  <div *ngIf="!isSearchLoading() && searchResults?.length > 0" class="shadow results">
    <!--      righe risultati-->
    <ng-container *ngFor="let draft of searchResults;let j = index">
      <div class="row justify-content-start m-0 p-2 bg-white" [ngClass]="{'colored-row': 0 !== j % 2}" *ngIf="j<5">
        <!--nome-->
        <div class="col-9 align-self-center primary-color">
          <a class="cursor-pointer"
             title="{{draft.name | translate}}"
             (click)="openProcess(draft)">
            <u class="text-truncate d-block text-justify no-underline">{{draft.name | translate}}</u>
          </a>
        </div>
        <!--          tipo-->
        <div class="col-3 align-self-center">
          <img src="ui-resources/{{draft.articleTypes[0]}}.png"
               class="img-fluid rounded pr-1" alt="{{draft.articleTypes[0]}}"
               title="{{'ARTICLE_TYPES.' + draft.articleTypes[0] | translate}}" style="height: 24px"></div>
      </div>
    </ng-container>
    <div class="row justify-content-start m-0 pl-0 bg-white" *ngIf="searchResults.length>5">
      <div class="col-12">{{'GOTO_BOZZE' | translate}}<i
        class="fas fa-arrow-right ml-2 cursor-pointer" (click)="openDrafts()"
        title="{{'GOTO_BOZZE' | translate}}"></i></div>
    </div>
  </div>
</div>

<div *ngIf="!isSearchLoading() && searchResults?.length < 1 && !boxView" class="alert alert-warning m-2 rounded" role="alert">
  <div class="ml-2">{{'result-not-found' | translate}}</div>
</div>

<div *ngIf="!isSearchLoading() && searchResults?.length < 1 && boxView" class="badge badge-warning p-2">
  <span>{{'NO_DRAFTS' | translate}}</span>
</div>

<app-edit-draft-modal [draft]="draftToEdit" (callbackAction)="onEditedDraft()"></app-edit-draft-modal>
